<template>
  <b-input-group>
    <b-input-group-text>
      <b-checkbox-group 
        :checked="value"
        :options="[...options]"
        size="sm"
        @change="$emit('input',$event)"
      />
    </b-input-group-text>
    <b-button-group size="sm">
      <b-button 
        small 
        @click="$emit('input',options.map(o => o.value))"
      >
        Hele dag
      </b-button>
      <b-button 
        small 
        @click="$emit('input',[])"
      >
        Geen
      </b-button>
    </b-button-group>
  </b-input-group>
</template>

<script>
export default {
name: 'HinderInput',
components: {},
mixins: [],
props: {
    value: {
        type: Array,
        default: () => []
    }
},
data() {
    return  {
        options: [
          {text:'tot 8:00',value: 8 },
          {text:'8.00 - 12.00',value: 812},
          {text:'12.00 - 17.00',value: 1217},
          {text:'na 17.00',value: 17}],
    }
},
computed: {},
watch: {},
mounted () {
    
},
methods: {},

}
      
</script>